/**
 * @module keywords
 * @description
 * A list of keywords used in specification.
 */
module.exports = [
  '$ref',
  '$schema',
  'type',
  'not',
  'anyOf',
  'allOf',
  'oneOf',
  'properties',
  'patternProperties',
  'additionalProperties',
  'items',
  'additionalItems',
  'required',
  'default',
  'title',
  'description',
  'definitions',
  'dependencies',
  '$id',
  'contains',
  'const',
  'examples'
];



// WEBPACK FOOTER //
// ./lib/utils/keywords.js